import { ConfigSettingRulesVm, FeatureSwitchVm } from "api/generated/lumen";
import { useTranslation } from "react-i18next";
import useConfigurationQuery from "./queries/useConfigurationQuery";

type FeatureNPatternKeyMap = Record<
  keyof FeatureSwitchVm,
  keyof ConfigSettingRulesVm | undefined
>;

const featureNPatternMap: FeatureNPatternKeyMap = {
  failureDescription1: undefined,
  failureDescription2: undefined,
  failureListParam1: undefined,
  failureListParam2: undefined,
  maintainedDevices: undefined,
  failureSpecialCase: undefined,
  exam: undefined,
  contractorAcceptOfTaskAssignment: undefined,
  failureCommentExtra: undefined,
};

const useFeature = (feature: keyof FeatureSwitchVm) => {
  const query = useConfigurationQuery();
  const { t } = useTranslation();

  const patternKey = featureNPatternMap[feature];

  const featureItem = query.data?.featureSwitch?.[feature];

  const featureData = {
    isEnabled: false,
    label: "",
    showInMasterView: false,
    formRules:
      patternKey && query.data?.rules?.validation !== undefined
        ? [
            {
              pattern: query.data?.rules?.validation,
              message: t("error.common.pattern"),
            },
          ]
        : [],
  };

  if (typeof featureItem === "boolean") {
    return { ...featureData, isEnabled: featureItem };
  } else {
    return {
      ...featureData,
      isEnabled: featureItem?.enabled,
      label: featureItem?.displayName,
      showInMasterView: featureItem?.showInMasterView,
    };
  }
};

export default useFeature;
